import { StyledText, StyledTextProps } from './styled';

export type { TextVariants } from './types';

export type TextProps = StyledTextProps & {
    as?: React.ElementType<HTMLElement>;
};

/**
 * Override rendered markup with `as` attribute. For instance:
 *
 * ```tsx
 * <Text as="span">An span in markup.</Text>
 * ```
 */

export const Text = StyledText;
